import RaceManage from './RaceManage';
import RaceManageRacialTrait from './RaceManageRacialTrait';

export default RaceManage;
export { RaceManage, RaceManageRacialTrait };
